import mfeDatalayer from '@mfe/data-layer';

export const datalayerInstance = () => {
  if (!window.gap.datalayer) {
    window.gap.datalayer = mfeDatalayer;
    return mfeDatalayer;
  }
  return window.gap.datalayer;
}
